module.exports = __webpack_public_path__ + "img/rulesTips.4c107799.svg";